import { render } from "./FacebookRedirectView.vue?vue&type=template&id=85e120b8"
import script from "./FacebookRedirectView.vue?vue&type=script&lang=js"
export * from "./FacebookRedirectView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__